import type { TFunction } from 'i18next';

type AccomodationDetail = {
  guests?: number | null;
  rooms?: number | null;
  beds?: number | null;
  baths?: number | null;
};

/**
 * Compose a localized details line like: "2 guests • 1 room • 2 beds • 1 bath".
 * - Omits any segment with value <= 0 or not provided
 * - Uses existing i18n keys only: apartment.guests, apartment.room, apartment.bed, apartment.bath
 */
export function formatApartmentDetailsLine(
  accomodationdetail: AccomodationDetail | undefined,
  t: TFunction,
  options?: { omitZero?: boolean }
): string {
  if (!accomodationdetail) return '';
  const { guests, rooms, beds, baths } = accomodationdetail;
  const omitZero = options?.omitZero === true;

  const segments: string[] = [];

  if (typeof guests === 'number' && (!omitZero || guests > 0)) {
    segments.push(`${guests} ${t('apartment.guests')}`);
  }
  if (typeof rooms === 'number' && (!omitZero || rooms > 0)) {
    segments.push(`${rooms} ${t('apartment.room', { count: rooms })}`);
  }
  if (typeof beds === 'number' && (!omitZero || beds > 0)) {
    segments.push(`${beds} ${t('apartment.bed', { count: beds })}`);
  }
  if (typeof baths === 'number' && (!omitZero || baths > 0)) {
    segments.push(`${baths} ${t('apartment.bath', { count: baths })}`);
  }

  return segments.join(' • ');
}

export default formatApartmentDetailsLine;
